import React, { useState, useEffect,useMemo } from 'react';

import DrawingPanel from "./DrawingPanel";
import {Box, Button, InputBase, Stack, Typography,useTheme, TextField} from "@mui/material";
import Header from "../global/Header";
import { useSearchParams } from "react-router-dom";
import { setupImage, setupNewImage , setLoading, selectImageString} from "../../slices/sign_image_editor"

import { useDispatch, useSelector , shallowEqual} from "react-redux";

import FramesList from "./FramesList";
import ColourPicker from "./ColourPicker";
import InfoArea from "./InfoArea"
import ToolArea from './ToolArea';
import PreviewArea from './PreviewArea';
import ImageData from './ImageData';
import EditorButtons from "./EditorButtons"

const ImageEditor = (props) =>  {

  const theme = useTheme()
  const dispatch = useDispatch();

  const image = props.image;
  const closerFunc = props.closer;
  const senderFunc = props.sender;
  const sign = props.sign;

  const doneLoading = useSelector((state) => state.imageEditor.doneLoading);
  const imageName = useSelector((state) => state.imageEditor.name, shallowEqual);
  const selectedFrame = useSelector((state) => state.imageEditor.selectedFrame);
  const width = sign.columns;
  const height = sign.rows;

  useEffect(() => {
    
    dispatch(setLoading());

    if(image){

      const setup = {
        width: sign.columns,
        height: sign.rows,
        name: image.name,
        image: image.image,
      }
      dispatch(setupImage(setup));
    }
    else{
      const setup = {
        width: sign.columns,
        height: sign.rows,
        name: "New Image for - " + sign.name
      }
      dispatch(setupNewImage(setup));
    }

  }, []);

  let createMode = false;

  if (image == undefined){
    createMode = true;
  }
  else{
    createMode = false;
  };


  function doReset(doUpdate) {
    
    dispatch(setLoading());
    closerFunc(doUpdate);
  }



  return (
    <Box 
      display="flex" 
      flexDirection="column"
      alignItems="center"
    >
      <Header title ={createMode ? "Create new Sign Image" : "Edit Image"} subtitle = {imageName}/>

      <Box 
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        width = "100%"
      >

        <Box 
          display="flex"
          flexDirection="column"
        >        
          <Box mb="1.5rem">
            <ToolArea/>
          </Box>

          <Box mb="1.5rem">
            <ColourPicker/>
          </Box>

        </Box>


        <Box
          display="flex"
          justifyContent="center"
          alignItems="flex-start"
          width = "50%"
          p=" 0 1rem 0 1rem"
          mb="1rem"
        >
          {doneLoading &&
            <DrawingPanel height = {height} width = {width} selectedFrame = {selectedFrame}/>
          } 


        </Box>

        <Box
          display="flex"
          flexDirection="column"
          width = "20%"
          sx={{maxWidth: "20rem"}}
        >
          <Box mb="1.5rem">
            <InfoArea imageId = {image?.id}/>
          </Box>
          
          <Box mb="1.5rem">
            <PreviewArea imageId = {image?.id}/>
          </Box>

          <EditorButtons closerFunc = {doReset} signId = {sign.id} createMode = {createMode} imageId = {image?.id}/>

        </Box>

      </Box>

      <Box mb="1.5rem" width = "100%">
        <FramesList/>
      </Box>
      
      <Box mb="1.5rem" width = "100%">
        <ImageData/>
      </Box>

    </Box>
  );
}

export default ImageEditor;